// extracted by mini-css-extract-plugin
export default {"select":"styles_select__zafLz","withValue":"styles_withValue__Xkwfr","inline":"styles_inline__taDiT"};